import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { SectionsPropsType } from '../../../../sections/types';
import { renderAdvisorMessage } from '../../../../views/AdvisorMessage';

const SECTION_KEY_NAME = 'wallDeteriorationEvaluation';

export const wallDeteriorationEvaluationSection = async (props: SectionsPropsType) => {
  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        ありがとうございます。
      </>
    ),
  });
};
